import { ASTGeneratedOutput, Generator } from "@core/services/common/Generator";
import { OffersFilters, OffersState } from "@core/store/types/admin/offers";

export default function offers (
  filters: OffersFilters,
  excludedFilters: OffersFilters,
  limit: number,
  offset: number,
  sort: OffersState["sort"],
  order: OffersState["order"],
  isShowCommissions: boolean,
  showAdvertisers: boolean,
  showIndividualRates: boolean
): ASTGeneratedOutput {
  const money = ["value","currency"];
  const exclude = [];
  const include = [];
  if (showAdvertisers) {
    include.push(
      "items/advertiser/id",
      "items/advertiser/intId",
      "items/advertiser/login"
    );
  }
  if (showAdvertisers && showIndividualRates) {
    include.push(
      "items/individualPayouts/items/payout/value",
      "items/individualPayouts/items/payout/currency"
    );
  }
  if (!isShowCommissions) {
    exclude.push(
      "items/minimalCommission/value",
      "items/averageCommission/value",
      "items/minimalIndividualRate/value",
      "items/maximalIndividualRate/value",
      "items/finance/rate/value",
      "items/finance/rate/currency",
      "items/minimalCommission/currency",
      "items/averageCommission/currency",
      "items/minimalIndividualRate/currency",
      "items/maximalIndividualRate/currency"
    );
  }
  const params = {
    include,
    exclude
  };

  const gqlObject = {
    operation: "offers",
    
    fields: [
      {
        items: [
          "id",
          "intId",
          "slug",
          "isLaunched",
          "createdAt",
          "type",
          "labels",
          "vertical",
          "plannedStopAt",
          "isNewCreated",
          "stopReason",
          "stoppedAt",
          {
            minimalIndividualRate: money
          },
          {
            maximalIndividualRate: money
          },
          {
            minimalCommission: money
          },
          {
            averageCommission: money
          },
          {
            landing: [
              "currency",
              "cost"
            ]
          },
          {
            logo: [
              "url"
            ]
          },
          {
            previewLogo: [
              "url"
            ]
          },
          {
            detail: [
              "name"
            ]
          },
          {
            countries: [
              "id",
              "name",
              "alpha2"
            ]
          },
          {
            categories: [
              "id",
              "name"
            ]
          },
          {
            finance: [
              "withdrawType",
              "subGoalType",
              { rate: money },
              { payout: money }
            ]
          }
        ]
      },
      "count"
    ],
    
    variables: {
      filters: {
        type: "OfferListCriteriaFilters",
        value: filters
      },
      excludedFilters: {
        type: "OfferListCriteriaFilters",
        value: excludedFilters
      },
      limit: {
        type: "Int",
        value: limit
      },
      offset: {
        type: "Int",
        value: offset
      },
      sort: {
        type: "OfferListCriteriaSort",
        value: sort
      },
      order: {
        type: "SortOrder",
        value: order
      }
    }

  };

  return Generator.query(gqlObject, params);
}

